module.exports = __webpack_public_path__ + "img/icon-l-w.349e4fbf.svg";